import {catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {Parameter} from '../models/parameter';
import {Observable, of} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {api, handleError} from '../../shared/api-loaders';
import {ParameterKeys} from "../models/parameterKeys";
import {Stack} from '../models/Stack';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class StackService {

  constructor(private http: HttpClient, private _http: HttpClient) { }


  /** GET */
  getCurrentStack(): Observable<Stack> {
    return this._http
      .get(api.currentStack()).pipe(
        catchError(handleError),);
  }


}
